import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=3f81051c&scoped=true"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=3f81051c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81051c",
  null
  
)

export default component.exports